<template>
   <div class="invoiceInfo">
      <el-card class="box-card">
         <div slot="header" class="clearfix">
            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">刷新 </el-button>
         </div>
         <el-form :model="sendDataInfo" ref="ruleForm" label-width="200px" class="demo-ruleForm" :inline-message="false" :show-message="false">
            <el-form-item label="组织名称" prop="ormName">
               <el-input class="input" v-model="sendDataInfo.ormName" disabled></el-input>
            </el-form-item>
            <el-form-item label="社会统一信用代码" prop="socialcode">
               <el-input class="input" v-model="sendDataInfo.socialcode" disabled></el-input>
            </el-form-item>
            <el-form-item label="企业编码" prop="firmCode">
               <el-input class="input" v-model="sendDataInfo.firmCode" disabled></el-input>
            </el-form-item>
            <el-form-item label="委托经办人" prop="entrustAgent">
               <el-input class="input" v-model="sendDataInfo.entrustAgent" disabled></el-input>
            </el-form-item>
            <el-form-item label="销售方单位名称" prop="xhdwmc" :rules="{required: true, trigger: ['blur','change']}">
               <el-input class="input" v-model="sendDataInfo.xhdwmc"></el-input>
            </el-form-item>
            <el-form-item label="销售方银行/银行账号" prop="xhdwyhzh" :rules="{required: true, trigger: ['blur','change']}">
               <el-input class="input" v-model="sendDataInfo.xhdwyhzh"></el-input>
            </el-form-item>
            <el-form-item label="销售方单位地址电话" prop="xhdwdzdh" :rules="{required: true, trigger: ['blur','change']}">
               <el-input class="input" v-model="sendDataInfo.xhdwdzdh"></el-input>
            </el-form-item>
            <!-- <el-form-item label="销售方开户行" prop="xhdwkhh" :rules="{required: true, trigger: ['blur','change']}">
               <el-input class="input" v-model="sendDataInfo.xhdwkhh"></el-input>
            </el-form-item> -->
            <el-form-item label="是否默认拆分税率" prop="splitTax" :rules="{required: true, trigger: ['blur','change']}">
               <el-radio-group class="input" v-model="sendDataInfo.splitTax" size="medium">
                  <el-radio-button :label="0">否</el-radio-button>
                  <el-radio-button :label="1">是</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="是否默认勾选销方信息" prop="invoiceSaleinfo" :rules="{required: true, trigger: ['blur','change']}">
               <el-radio-group class="input" v-model="sendDataInfo.invoiceSaleinfo" size="medium">
                  <el-radio-button :label="0">否</el-radio-button>
                  <el-radio-button :label="1">是</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="是否默认勾选拼接批号信息" prop="invoiceBatch" :rules="{required: true, trigger: ['blur','change']}">
               <el-radio-group class="input" v-model="sendDataInfo.invoiceBatch" size="medium">
                  <el-radio-button :label="0">否</el-radio-button>
                  <el-radio-button :label="1">是</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="是否默认勾选购方信息" prop="invoiceDefault" :rules="{required: true, trigger: ['blur','change']}">
               <el-radio-group class="input" v-model="sendDataInfo.invoiceDefault" size="medium">
                  <el-radio-button :label="0">否</el-radio-button>
                  <el-radio-button :label="1">是</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="销售订单备注是否带入" prop="invoiceRemark" :rules="{required: true, trigger: ['blur','change']}">
               <el-radio-group class="input" v-model="sendDataInfo.invoiceRemark" size="medium">
                  <el-radio-button :label="0">否</el-radio-button>
                  <el-radio-button :label="1">是</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
            </el-form-item>
         </el-form>
      </el-card>
   </div>
</template>

<script>
export default {
   data() {
      return {
         sendDataInfo: {
            ormName: "",
            socialcode: "",
            firmCode: "",
            entrustAgent: "",
            xhdwmc: "",
            xhdwyhzh: "",
            xhdwdzdh: "",
            // xhdwkhh: "",
            splitTax: 0,
            invoiceSaleinfo:0,
            invoiceBatch:0,
            invoiceDefault: 0,
            invoiceRemark: 0,
         }
      }
   },
   watch: {

   },
   created() {
      this.getDataList()
   },
   methods: {
      getPageInfo() {
         this.getDataList()
      },
      async getDataList() {
         const res = await this.$http.getInvoiceInfo()
         if (res.status == 200) {
            sessionStorage.setItem('ormList',JSON.stringify(res.result))
            for (const key in res.result) {
               this.$set(this.sendDataInfo, key, res.result[key])
            }
         }
      },
      submitForm(formName) {
         this.$refs[formName].validate(async (valid) => {
            if (valid) {
               const res = await this.$http.OrganizationModify(this.sendDataInfo)
               if (res.status == 200) {
                  this.$alert('保存成功', '提示', {
                     confirmButtonText: '确定',
                     callback: action => { }
                  });
                  this.getDataList()
               }
            } else {
               this.$message.error("请完善信息！")
               return false;
            }
         });
      },
   },
   mounted() { }
}
</script>

<style scoped>
.box-card {
}
.invoiceInfo {
   padding: 20px;
}
::v-deep .el-card__header {
   padding: 10px 20px;
}
.input {
   width: 50vw;
}
</style>